// extracted by mini-css-extract-plugin
export default {"App":"App_App__mYa6v","App-logo":"App_App-logo__PBif9","App-logo-spin":"App_App-logo-spin__sr9fp","App-header":"App_App-header__p6IV8","App-link":"App_App-link__jzT3l"};